import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import Divider from "@mui/material/Divider";
import Walls from "./Walls/Walls";
import Materials from "./Materials/Materials";
import TabPanel from "@mui/lab/TabPanel";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginLeft: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);


function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function WallsTab(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <div className={classes.demo2}>
        <AppBar
          position="static"
          className={classes.demo2}
          style={{ boxShadow: "none", shadowColor: "red" }}
        >
          <StyledTabs
            initialselectedindex={0}
            scrollButtons="auto"
            value={value}
            onChange={handleTabChange}
            aria-label="Horizontal tabs"
            //className={classes.tabs}
            TabIndicatorProps={{ style: { background: "#91C73C" } }}
          >
            <StyledTab label="Cloisons" value={0} />
            <StyledTab label="Matériaux" value={1} />
          </StyledTabs>
        </AppBar>
        <Divider variant="fullWidth" />
        <TabPanel value={0} index={0}>
          {<Walls/>}
        </TabPanel>
        <TabPanel value={1} index={1}>
          {<Materials/>}
        </TabPanel>
      </div>
    </TabContext>
  );
}
